import { isFetcherError } from '../client';
export var isApiValidationError422 = function (error) {
    return isFetcherError(error) && error.status === 422;
};
